import React from 'react';
import Check from '../Icons/Check';
import { isNullOrUndefined } from '../../helpers/object-helpers';
import styles from './Checkbox.module.scss';
import ValidationMessage from '../ValidationMessage/ValidationMessage';
import AssistiveText from '../AssistiveText/AssistiveText';

export interface ICheckbox {
  id: string;
  children: React.ReactNode;
  disabled?: boolean;
  checked?: boolean;
  onChange?: () => void;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  name?: string;
  isValid?: boolean;
  errorMessage?: string;
  assistiveText?: string;
  validText?: string;
}

export default function Checkbox({
  id,
  children,
  onChange,
  disabled = false,
  checked = false,
  ariaLabel,
  ariaLabelledBy,
  name,
  isValid,
  errorMessage,
  assistiveText,
  validText,
}: ICheckbox) {
  const changeHandler = () => {
    if (!isNullOrUndefined(onChange)) onChange();
  };

  return (
    <div>
      <label htmlFor={id} className={styles.checkbox}>
        <input
          type="checkbox"
          disabled={disabled}
          id={id}
          name={name}
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledBy}
          checked={checked}
          onChange={() => {
            changeHandler();
          }}
        />
        <span
          className={[
            styles.checkmark,
            checked ? styles.checkmarkSelected : styles.checkmarkUnSelected,
          ].join(' ')}
        >
          {checked ? <Check /> : null}
        </span>
        <span className={styles.content} data-test={`${id}-label`}>
          {children}
        </span>
      </label>
      <ValidationMessage isValid={isValid} errors={[errorMessage]} validText={validText} />
      <AssistiveText>{assistiveText}</AssistiveText>
    </div>
  );
}
